export enum FileFormat {
    ZIP = 'zip',
    CBZ = 'cbz',
    MHTML = 'mhtml'
}